<template>
    <v-container class="content" >
      <LoginLogo />

      <v-row no-gutters justify="center" align="center" class="text-center mb-5">
        This functionality will be implemented shortly.
      </v-row>

      <v-row no-gutters justify="center" align="center" class="">
        <v-btn type="button" v-on:click="goBack" class="bg-primary">
          <v-icon>mdi-arrow-left</v-icon>
          Go Back
        </v-btn>
      </v-row>
    </v-container>
</template>

<script>
import LoginLogo from '../account/components/LoginLogo.vue'

export default {
  name: "SoonPage",
  components: {
    LoginLogo,
  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    }
  }
}
</script>
